import Tabs1 from "./tabs1/tabs1";

export default function _Tabs(props) {
  let eleHTML = <></>;
  if (!props.display) return eleHTML;
  switch (props.display) {
    case "tabs1":
      eleHTML = <Tabs1 options={props.options} props={props} />;
      break;
    default:
      break;
  }

  return eleHTML;
}
